/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';

import {AdnApiClientService} from '../../controller/adn-api-client.service';
import {
  SignalAdminResourceApiBase,
  SignalAdminResourceModel,
  SignalAdminResourcePage
} from '../../controller/signal-admin-resource-api';

export interface NoteModel extends SignalAdminResourceModel {
  data?: string | string[];
  dataType?: string;
  [key: string]: any;
}

@Injectable({providedIn: 'root'})
export class NoteApiService extends SignalAdminResourceApiBase<NoteModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'notes');
  }

  queryByIds(ids: string[]): Observable<SignalAdminResourcePage<NoteModel>> {
    if (!ids.length) {
      return of({results: [], totalCount: 0, page: 0});
    }
    const limitedIds = ids.slice(0, 1001);
    return this.client.request<SignalAdminResourcePage<NoteModel>>({
      method: 'GET',
      url: this.resourceUri('notes'),
      params: {
        id: limitedIds.join(';'),
        pageSize: limitedIds.length,
        includeHidden: false,
        includeActive: true,
        includeInactive: false,
        orderBy: 'createTime'
      }
    });
  }
}
